export class Cached<T> {
    private value: T;
    private valuePromise: Promise<T> | null;

    public constructor(private fetch: () => Promise<T>) {}

    public async getValue(): Promise<T> {
        if (this.value) {
            return this.value;
        }
        if (this.valuePromise) {
            return await this.valuePromise;
        }
        const promise = this.fetch().then(v => {
            this.value = v;
            this.valuePromise = null;
            return v;
        });
        this.valuePromise = promise;
        return await promise;
    }
}
